export default function toClearBrackets(text) {
    return text.replace(/^\[[^\]]+\] - /, '');
}